import { compact } from 'lodash-es';
import { dateRangeBounds, dateRangeFromPickers, rangeDateValueLabel } from '~/components/AiSearchChips/DateRangeChip/DateRangeChip.utils';
export const START_BILLING_AT_DATE_OPTION = 'date';
export const startBillingAtDateBounds = (date)=>dateRangeBounds(date);
export const startBillingAtDateLabel = (date, t)=>rangeDateValueLabel(date, t.servicesStartBillingAtDateLabel());
export const startBillingAtDateFromRadio = (param)=>{
    let { selected, from, to } = param;
    if (selected !== START_BILLING_AT_DATE_OPTION) return undefined;
    return dateRangeFromPickers({
        from,
        to
    });
};
const dateImpliesExists = (startBillingAt)=>startBillingAt.exists === true && startBillingAt.date != null;
export const startBillingAtToggledExists = (startBillingAt)=>startBillingAt == null || dateImpliesExists(startBillingAt) ? undefined : startBillingAt.exists;
export const startBillingAtExistsChipLabels = (exists, t)=>exists ? {
        fieldLabel: t.servicesHasLabel(),
        valueLabel: t.servicesStartBillingAtLabel()
    } : {
        fieldLabel: t.servicesStartBillingAtLabel(),
        valueLabel: t.servicesStartBillingAtNoneLabel()
    };
const existsSegment = (exists, t)=>exists ? t.servicesStartBillingAtExistsLabel() : t.servicesStartBillingAtNoneLabel();
export const startBillingAtSegments = (startBillingAt, t)=>{
    if (startBillingAt == null) return [];
    const toggledExists = startBillingAtToggledExists(startBillingAt);
    const date = startBillingAt.date;
    return compact([
        toggledExists != null && existsSegment(toggledExists, t),
        date != null && "".concat(t.servicesStartBillingAtLabel(), " ").concat(startBillingAtDateLabel(date, t))
    ]);
};
export const startBillingAtNoun = (startBillingAt, t)=>{
    if (startBillingAt == null || startBillingAt.exists === false) return null;
    const date = startBillingAt.date;
    if (date != null) return "".concat(t.servicesStartBillingAtNoun(), " ").concat(startBillingAtDateLabel(date, t));
    return startBillingAt.exists === true ? t.servicesStartBillingAtNoun() : null;
};
